import { Link as RouterLink } from 'react-router-dom'
import {
    Box,
    Heading,
    Text,
    SimpleGrid,
    LinkBox,
    LinkOverlay,
    Flex,
    Icon
} from '@chakra-ui/react'
import { RESOURCES } from '@/modules/admin/schema'

export default function AdminHome() {
    return (
        <Box>
            <Heading size="lg" mb={1}>
                Anointed Kids Zone — Content Management
            </Heading>
            <Text color="gray.600" mb={6}>
                Create, edit and remove the content shown in the Anointed Kids Zone of the
                Heritage mobile app.
            </Text>
            <SimpleGrid columns={{ base: 1, sm: 2, lg: 3 }} spacing={4}>
                {RESOURCES.map((r) => (
                    <LinkBox
                        key={r.resource}
                        as="article"
                        bg="white"
                        p={5}
                        borderRadius="md"
                        borderWidth="1px"
                        _hover={{ shadow: 'md', transform: 'translateY(-2px)' }}
                        transition="all 0.15s"
                    >
                        <Flex align="center" gap={2} mb={2}>
                            <Icon as={r.icon} color="brand.400" />
                            <Heading size="sm">
                                <LinkOverlay as={RouterLink} to={`/admin/${r.resource}`}>
                                    {r.label}
                                </LinkOverlay>
                            </Heading>
                        </Flex>
                        <Text fontSize="sm" color="gray.600">
                            {r.description}
                        </Text>
                    </LinkBox>
                ))}
            </SimpleGrid>
        </Box>
    )
}
